export default "__VITE_ASSET__p6YnW09p__"